/**
 * This module initiates/stops things associated with the metawear bracelet.  Things
 * include: reading the step counter, pulse rate, etc.
 */

/**
 * This module provides interaction with all the bracelets that the current
 * machine is physically connected to (via Bluetooth).  It's state is an
 * array of objects with key = mac and value is an object {id: mac, model: string}
 */

var Model = require("../types/Model.js");
var later = require("later/index-browserify.js");

// default to a two-hour/on-the-hour interval between readings
var DEFAULT_INTERVAL = "0 0-23/2 * * *";

module.exports = new Model({
	name: "metawearscheduler",
	init: init,
	uninit: uninit,
	listeners: listeners,

	_mac: null,
	_model: null,
	_timer: null,
	_interval: DEFAULT_INTERVAL,

	beginconnect: beginconnect,
	handle_reset_timer: handle_reset_timer,
	scheduleReadings: scheduleReadings,
	_connected: false,

});

function init() {
	// reads config to see desired interval
	var config_interval = this.config.metawear_read;
	if (config_interval) this._interval = config_interval;
	if (!this._interval) later.date.localTime();

	this._mac = [];
	this.push(false);
}

function uninit() {
	if (this._timer) {
		this._timer.clear();
		this._timer = null;
	}
}

function listeners() {
	return {
		"braceletdata:updated": handle_settings_update,
		"owndevices:updated": handle_devices_update
	};
}

function handle_settings_update(data) {
	var mac = data.mac;
	var model = data.model;

	// Return if the mac is an empty string/undefined
	// or the model is not the metawear in 'auto' mode
	// i.e. 'meta_auto'
	if (model !== "meta" || !mac){
		this._mac = null;
		this._model = null;
		if(!this._macs.length){
			this.push(false);
			this.handle_reset_timer();
		}
		return;
	}

	// Don't bother reacting if nothing has changed
	if ((mac === this._mac) && (model === this._model))
		return;

	this.scheduleReadings();

	this._mac = mac;
	this._model = model;

}

function handle_devices_update(data){
	var list = data.list;
	var oldList = this._macs;

	var newList = list.reduce(function(acc, item){
		if(item.automatic) acc = acc.concat(item.mac);
		return acc;
	}, []);

	if(!newList.length) {
		this._macs = newList;
		if(!this._mac){
			this.push(false);
			this.handle_reset_timer();
		}
		return;
	}

	var hasChanged = compare(newList, oldList);

	if(!hasChanged) return;

	this._macs = newList;
	this.scheduleReadings();
}

function scheduleReadings(){
	// Clear whatever current settings because they aren't valid
	this.handle_reset_timer();

	this.push(true);

	this.emit("bluetooth:trigger:initialize");

	var schedule = calculate_schedule(this._interval);

	var timer = later.setInterval(beginconnect.bind(this), schedule);
	this._timer = timer;
}

function beginconnect() {
	this.emit("myhealthdevice:trigger:begin", {
		deviceType: "activity",
		automatic: true
	});
}

function handle_reset_timer() {
	// Clear the timer if there is one
	if (this._timer) {
		this._timer.clear();
	}
	this._timer = null;
}

/**
 * Calculates the schedule object for a cron schedule string
 * @param  {String} schedule The schedule string to parse out
 * @return {Object}          The resulting later.js schedule
 */
function calculate_schedule(schedule) {
	return later.parse.cron(schedule);
}

function compare(arr1, arr2){
	return arr1.reduce(function(accumulator, element){
		if(arr2.indexOf(element) === -1) accumulator = true;
		return accumulator;
	}, false);
}